import { httpClient } from '@client/new/api/api';

const FEATURE = 'ExercisesCatalog';

export type FeedbackPayload = Record<string, unknown>;

export type FeatureFeedbackResponse = {
  id: number;
  portalUserId: number;
  feature: string;
  feedback: FeedbackPayload;
  createdAt: string;
};

export const getFeatureFeedback = async (): Promise<
  FeatureFeedbackResponse[]
> => {
  const response = await httpClient.get<FeatureFeedbackResponse[]>(
    '/creator/feedback',
    { params: { feature: FEATURE } },
  );
  return response.data;
};

export const createFeatureFeedback = async (
  feedback: FeedbackPayload,
): Promise<FeatureFeedbackResponse> => {
  const response = await httpClient.post<FeatureFeedbackResponse>(
    '/creator/feedback',
    { feature: FEATURE, feedback },
  );
  return response.data;
};
